import { Injectable }         from '@angular/core';
import { Http, Response }     from '@angular/http';
import { Router }             from '@angular/router';
import { Globals }            from './../common/globals';
import { authHeaders }        from '../common/headers';
import { Observable }         from 'rxjs/Observable';
import { AuthHttp,
         JwtHelper,
         tokenNotExpired }    from 'angular2-jwt';


@Injectable()
export class AuthService {

  token: string;
  private appLogin = 'SAPortal';
  private appPwd = '5dc6553d581e';

  constructor(
    private http: Http,
    public authHttp: AuthHttp,
    public globals: Globals,
    public router: Router) {
  }

  login(username: string, password: string, rememberMe: boolean) {
    let body = 'username=' + username + '&password=' + password
                + '&client_id=' + this.appLogin + '&client_secret=' + this.appPwd + '&grant_type=password';
    let request = this.http.post( this.globals.GetUrlPrefix() +  '/connect/token', body, { headers: authHeaders });
    let response = request
        .map((res: Response) => {
            // login successful if there's a jwt token in the response
            let token = res.json() && res.json().access_token;
            if (token) {
                let jwtHelper = new JwtHelper();
                let decodedToken = jwtHelper.decodeToken(token);
                // set token property
                this.token = token;

                // store username and jwt token in local storage to keep user logged in between page refreshes
                sessionStorage.setItem('id_token', token);
                this.globals.roles = [];
                if (!!decodedToken.roles) {
                  this.globals.roles = decodedToken.roles.split(';');
                }
                // DO NOT USE!!! BAD APPROACH! NEVER STORE USERNAME / PASSWORD
                // http://bitoftech.net/2014/07/16/enable-oauth-refresh-tokens-angularjs-app-using-asp-net-web-api-2-owin/
                // Po dohode s Honzou disabled, zatim sliding expiration nebudeme resit
                // Ciste reseni je komplikovane na strane serveru,
                // http://bitoftech.net/2014/07/16/enable-oauth-refresh-tokens-angularjs-app-using-asp-net-web-api-2-owin/

                // to support sliding expiration
                // sessionStorage.setItem('profile', btoa(JSON.stringify({ 'u': username, 'p': password, 'r': rememberMe })));
                return true;
            } else {
                // return false to indicate failed login
                return false;
            }
        })
        .catch((error: any) => {
            console.log('catching exception');
            return Observable.throw(error.json().error || 'Server error');
        }
        );

    return response;
  }

  // Logout the user
  logout() {
    sessionStorage.removeItem('profile');
    sessionStorage.removeItem('id_token');
    this.globals.roles = [];
    // Send the user back to the dashboard after logout
    this.router.navigateByUrl('/login');
  }

/*
  refreshToken() {
    let p = JSON.parse(atob(sessionStorage.getItem('profile')));
    return this.login(p.u, p.p, p.r);
  }
  */

  // Check whether the user is logged in or not
  loggedIn() {
    return tokenNotExpired('id_token', sessionStorage.getItem('id_token'));
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/auth.service.ts